import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { isExisty } from 'utils/helpers.util';
import { getGUID, getUserTokenFromCookie } from 'utils/cookies.util';
import { NEW_CHECKOUT_PAGE, EUrlParams } from 'config/Urls.config';
import history from 'routes/customHistory';
import Constants from 'config/constants';
import { IAppState } from 'config/redux/reducers';
import { showNotification } from 'common/Notification/redux/notification.action';
import { initStorageManager } from 'utils/customStorage.util';
import APP_CONFIG from 'config/App.config';
import { mergeCarts } from '../redux/actions/mergeCarts.actions';
import useSessionArea from 'services/sessionArea/hooks/useSessionArea.hook';
import useNewC4Journey from 'hooks/useNewC4Journey';
import { notificationTypes } from 'common/Notification/redux/notification.type';
import { getCartPageUrl } from 'utils/cartRevamp.util';
import useCartRevampEnabled from 'hooks/useCartRevampEnabled';
// /app/cart/merge - stays on Cart page and will do merge
// /app/cart/checkout - redirect to SPC if no cart merge
const storage = initStorageManager(() => localStorage);

export default function(t: any) {
  const { action } = useParams();
  const dispatch = useDispatch();
  const [sessionArea] = useSessionArea();
  const isCartRevampEnabled = useCartRevampEnabled();
  const { storeId, language } = useSelector((state: IAppState) => state.appConfig);
  const { cart, newCart } = useSelector((initialAppState: IAppState) => {
    return { cart: initialAppState.cart, newCart: initialAppState.newCart };
  });
  const NEW_CART_PAGE = getCartPageUrl(storeId, language, isCartRevampEnabled);
  const isNewJourney = useNewC4Journey();

  const totalUnitCount =
    (isNewJourney ? newCart.cartData.totalItems : cart.cartData.totalUnitCount) || 0;

  if (!isExisty(action)) {
    return;
  }
  const loggedIn = isExisty(getUserTokenFromCookie());

  if (action !== EUrlParams.EXPRESS) {
    let isMerged = false;
    const guestCartQuantityFromLocalStorage = storage.getItem(Constants.guestCartQuantity);
    if (loggedIn && guestCartQuantityFromLocalStorage) {
      const guestCartQuantity = JSON.parse(guestCartQuantityFromLocalStorage);

      if (!!guestCartQuantity && guestCartQuantity !== totalUnitCount) {
        if (APP_CONFIG.isNewEndpoint) {
          isMerged = true;
          const guestCart = getGUID();
          const hasSessionArea = isExisty(sessionArea);
          const successCallback = (hasMerged: boolean) => {
            const isRedirectToSPC = action === 'checkout';
            // No merge has happened, take the user to SPC!
            if (!hasMerged && isRedirectToSPC) {
              history.push(NEW_CHECKOUT_PAGE, { forceLoadSPC: true });
            }
          };

          if (hasSessionArea) {
            dispatch(
              mergeCarts({
                areacode: sessionArea,
                toMergeCartGuid: guestCart,
                successCallback,
                t,
              })
            );
          }
        } else {
          const mergeCartMessage = t('mergeCart');
          isMerged = true;
          dispatch(
            showNotification({
              type: notificationTypes.success,
              message: mergeCartMessage,
            })
          );
          if (isCartRevampEnabled) {
            window.location.href = NEW_CART_PAGE;
          } else {
            history.replace(NEW_CART_PAGE);
          }
        }
      }
      if (!isMerged && action === 'checkout') {
        history.push(NEW_CHECKOUT_PAGE, { forceLoadSPC: true });
      }
      storage.removeItem(Constants.guestCartQuantity);
    }
  }
}
